export const ASSIGN_TO_ME_ANALYTICS = Object.freeze({
	ACTION: 'clicked',
	ACTION_SUBJECT: 'assignToMeButton',
});

export const ONLOAD_ASSIGN_TO_ME_ANALYTICS = Object.freeze({
	ACTION: 'viewed',
	ACTION_SUBJECT: 'assignToMe',
});
